<div class="notification">
  <div class="notification__message">
    <mat-icon>info</mat-icon>
    <p [innerHTML]="'NOTIFICATION.NEW_APP_VERSION_IS_AVAILABLE' | translate"></p>
  </div>
  <div class="notification__actions">
    <button mat-raised-button color="primary" (click)="reloadPage()">
      {{ "NOTIFICATION.RELOAD_PAGE" | translate }}
    </button>
    <button mat-button color="primary" (click)="close()">
      {{ "NOTIFICATION.CLOSE" | translate }}
    </button>
  </div>
</div>
